import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { Transition as t, createBlock as n, createCommentVNode as r, createElementVNode as i, guardReactiveProps as a, mergeProps as o, normalizeProps as s, openBlock as c, renderSlot as l, vShow as u, withCtx as d, withDirectives as f } from "vue";
//#region components/lazy_show/lazy_show.vue
var p = {
	compatConfig: { MODE: 3 },
	name: "DtLazyShow",
	inheritAttrs: !1,
	props: {
		show: {
			type: Boolean,
			default: !1
		},
		transition: {
			type: String,
			default: null
		},
		appear: {
			type: Boolean,
			default: !1
		}
	},
	data() {
		return { initialized: !!this.show };
	},
	computed: { isCSSEnabled() {
		return process.env.NODE_ENV !== "test";
	} },
	watch: { show: function(e) {
		!e || this.initialized || (this.initialized = !0);
	} }
};
function m(e, p, m, h, g, _) {
	return c(), n(t, o({
		name: m.transition,
		appear: m.appear
	}, e.$attrs, { css: _.isCSSEnabled }), {
		default: d(() => [f(i("div", s(a(e.$attrs)), [g.initialized ? l(e.$slots, "default", { key: 0 }) : r("", !0)], 16), [[u, m.show]])]),
		_: 3
	}, 16, [
		"name",
		"appear",
		"css"
	]);
}
var h = /* @__PURE__ */ e(p, [["render", m]]);
//#endregion
export { h as default };

//# sourceMappingURL=lazy-show.js.map